import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from 'redux-form/es/actions';
import { toggleAddressDetails } from 'actions/loan';
import AddressDetails from 'components/Credit24/LoanApplication/AddressDetailsAU';
import { auResidenceUpgrade, statesAU } from 'consts';
import { useApplicationFlags } from 'hooks/useApplicationFlags';

const { change } = actions;

const propTypes = {
  toggleAddressDetails: PropTypes.func.isRequired,
  loan: PropTypes.object.isRequired,
  submitFailed: PropTypes.bool,
  change: PropTypes.func,
};

const googleResultsMap = {
  route: 'street',
  street_number: 'streetNumber',
  postal_code: 'postCode',
  locality: 'city',
  administrative_area_level_1: 'addressState',
  subpremise: 'unitNumber',
};

const AddressDetailsAUContainer = ({
  toggleAddressDetails, loan, submitFailed, change,
}) => {
  const { isOcmOrUpgrade } = useApplicationFlags();

  const onSuggestSelected = (geoAddress) => {
    Object.keys(googleResultsMap).forEach((field) => {
      const matchingResult = geoAddress.address_components.filter((item) =>
        item.types[0] === field);

      let val = matchingResult && matchingResult.length ? matchingResult[0].long_name : '';
      if (field === 'administrative_area_level_1') {
        val = matchingResult && matchingResult.length ? matchingResult[0].short_name : '';
      }
      change('loan', googleResultsMap[field], val);
    });
    toggleAddressDetails();
  };

  const residenceStatus = isOcmOrUpgrade && { residenceTypes: auResidenceUpgrade };

  return (
    <AddressDetails
      submitFailed={submitFailed}
      onSuggestSelected={onSuggestSelected}
      areAddressDetailsHidden={loan.areAddressDetailsHidden}
      toggleAddressDetails={toggleAddressDetails}
      states={statesAU}
      {...residenceStatus}
    />
  );
};

AddressDetailsAUContainer.propTypes = propTypes;

export default connect(
  (state) => ({
    submitFailed: state.form.loan.submitFailed,
  }),
  {
    toggleAddressDetails,
    change,
  }
)(AddressDetailsAUContainer);
